import { EditorView } from '@codemirror/view';
import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
function createTheme({
  variant,
  settings,
  styles
}) {
  const theme = EditorView.theme({
    '&': {
      backgroundColor: settings.background,
      color: settings.foreground
    },
    '.cm-content': {
      caretColor: settings.caret,
      fontFamily: settings.fontFamily
    },
    '.cm-cursor, .cm-dropCursor': {
      borderLeftColor: settings.caret
    },
    '&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection': {
      backgroundColor: settings.selection
    },
    '.cm-foldPlaceholder': {
      backgroundColor: 'transparent',
      border: `1px solid ${settings.foreground}`
    },
    '.cm-activeLine': {
      backgroundColor: settings.lineHighlight
    },
    '.cm-gutters': {
      backgroundColor: settings.gutterBackground,
      color: settings.gutterForeground
    },
    '.cm-activeLineGutter': {
      backgroundColor: settings.lineHighlight
    }
  }, {
    dark: variant === 'dark'
  });
  const highlightStyle = HighlightStyle.define(styles);
  const extension = [theme, syntaxHighlighting(highlightStyle)];
  return extension;
}
export default createTheme;